<template>
  <v-card
    class="mx-auto"
  >
    <v-img
      class="white--text align-end"      
      :src="product.image_url"
      contain
      max-height="360px"
      
    >      
    </v-img>

    <v-card-actions align="center">
      <v-row
          align="center"
          justify="center"
        >
          <v-btn v-if="getUrl(product.product_id) != ''"
            :href="getUrl(product.product_id)"
            target="_blank"
          >
            Show product sheet
          </v-btn>
        </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import * as Adjustment from '../../tools/productsDB.js';

export default {
  name: 'ImageCard',
  props: {
    product: {
      product_id: Number,
      image_url: String
    }
  },
  mounted () {
    
  },
  methods:{
    getUrl(id){
      let target = Adjustment.products.find((p) => p.product_id == this.product.product_id )
      if (target){
        if ( target.product_adjust != 0 )
          return 'https://digital.barcelonabridalweek.com/product/#/'+target.product_adjust
        else
          return ''      
      }else{
        return 'https://digital.barcelonabridalweek.com/product/#/'+id
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
